'use es6';

import { DragDropContext, HTML5Backend } from 'react-dnd-compat';
export default DragDropContext(HTML5Backend);